module.exports = __webpack_public_path__ + "img/01.701fbf0a.png";